<app-benefits-list
  [benefitsListItems]="benefitsListNotCoveredItems()"
  [iconTemplate]="iconTemplateNotCoveredItems"
  [title]="title()"
>
  <ng-template #iconTemplateNotCoveredItems let-icon="iconName">
    <div class="benefits-list-not-covered-items__icon-container">
      <app-icon
        [family]="'solid'"
        [name]="icon"
        [size]="'sm'"
        class="benefits-list-not-covered-items__icon"
      />
    </div>
  </ng-template>
</app-benefits-list>
